import { jsx } from "react/jsx-runtime";
import { Loader } from "../../vendor/@googlemaps/js-api-loader/dist/index.js";
import { createContext, useContext, useState, useEffect } from "react";
const GoogleLoaderContext = createContext(void 0), GoogleLoaderProvider = ({ children, apiKey, language: inputLng }) => {
  const ctx = useContext(GoogleLoaderContext), [loader, setLoader] = useState(ctx), [language, region] = (inputLng == null ? void 0 : inputLng.split("-")) ?? [];
  return useEffect(() => {
    if (!language || !region || !apiKey) return;
    const loader2 = new Loader({
      apiKey,
      version: "weekly",
      region,
      language
    });
    setLoader(loader2);
  }, [apiKey, language, loader, region]), /* @__PURE__ */ jsx(GoogleLoaderContext.Provider, { value: loader, children });
}, useGoogleLoader = () => useContext(GoogleLoaderContext);
export {
  GoogleLoaderProvider,
  useGoogleLoader
};
//# sourceMappingURL=GoogleLoaderProvider.js.map
